import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: `/hy/fund-types`, params });
